import {createSelector} from 'reselect';
import getSelectedPaymentOptionTypeForGenericBillingAddress
from './getSelectedPaymentOptionTypeForGenericBillingAddress';

const getBillingAddress = state => state.address?.genericBillingAddress;

export default createSelector(
  [getSelectedPaymentOptionTypeForGenericBillingAddress, getBillingAddress],
  (selectedPaymentOptionTypeForGenericBillingAddress, billingAddress) => {
    if (selectedPaymentOptionTypeForGenericBillingAddress) {
      return billingAddress[selectedPaymentOptionTypeForGenericBillingAddress] || {};
    }
    
    return {};
  },
);
